// @ts-nocheck
import {
  CFG,
  DISCORD_INVITE_URL,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SHOP_CATEGORY_ORDER,
  SPELLS_IN_CATEGORY,
  shopCategoryLabel,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  normalizeBotSkill,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  PVE_GAUNTLET,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../audio";
import {
  spellIconInner,
  spellLabelHTML,
} from "../spell-icons";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  playerNameHTML,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../lobby";
import { renderPatchNotes } from "../patch-notes";

import { Game } from "./game-base";

const NICKNAME_TAKEN_MSG = "another Warlock has already taken that nickname, try another one.";
const NICKNAME_LOCKED_MSG = "Your nickname is locked and cannot be changed.";
const HANDLE_PATTERN = /^[a-z0-9]+$/i;

function normalizeHandleInput(raw) {
  return (raw || "").trim().toLowerCase();
}

function validateHandleLocal(raw) {
  const handle = normalizeHandleInput(raw);
  if (!handle) return "Choose a nickname.";
  if (handle.length > 14) return "Nickname is too long.";
  if (!HANDLE_PATTERN.test(handle)) return "Letters and numbers only.";
  return "";
}

function setHandleCheckStatus(el, state, text) {
  if (!el) return;
  el.textContent = text || "";
  el.classList.remove("is-ok", "is-bad", "is-wait");
  if (state) el.classList.add(state);
}

Game.prototype.checkHandleAvailable = async function (handle) {
  const localErr = validateHandleLocal(handle);
  if (localErr) return { available: false, handle: normalizeHandleInput(handle), reason: localErr };
  try {
    const q = new URLSearchParams({ handle: normalizeHandleInput(handle) });
    const res = await fetch(`/auth/handle/check?${q}`, { cache: "no-store", credentials: "same-origin" });
    if (!res.ok) return { available: false, handle: normalizeHandleInput(handle), reason: "Could not check nickname." };
    return await res.json();
  } catch (e) {
    return { available: false, handle: normalizeHandleInput(handle), reason: "Could not reach the server." };
  }
}

Game.prototype.bindHandleAvailability = function (input, statusEl) {
  if (!input || input.dataset.handleCheckBound) return;
  input.dataset.handleCheckBound = "1";
  let timer = null;
  let seq = 0;
  const run = () => {
    const handle = normalizeHandleInput(input.value);
    const localErr = validateHandleLocal(handle);
    if (localErr) {
      setHandleCheckStatus(statusEl, localErr === "Choose a nickname." ? "" : "is-bad", localErr === "Choose a nickname." ? "" : localErr);
      return Promise.resolve({ available: false, reason: localErr });
    }
    const mySeq = ++seq;
    setHandleCheckStatus(statusEl, "is-wait", "Checking availability…");
    return this.checkHandleAvailable(handle).then((data) => {
      if (mySeq !== seq) return data;
      if (data.available) {
        setHandleCheckStatus(statusEl, "is-ok", "Nickname is available.");
      } else {
        setHandleCheckStatus(statusEl, "is-bad", data.reason || NICKNAME_TAKEN_MSG);
      }
      if (data.handle && data.handle !== handle) input.value = data.handle;
      return data;
    });
  };
  const schedule = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => { timer = null; void run(); }, 280);
  };
  input.addEventListener("input", schedule);
  input.addEventListener("blur", () => { if (timer) clearTimeout(timer); void run(); });
  input._runHandleCheck = run;
}

Game.prototype.showNicknamePicker = function ({ title, body, initial = "", required = true } = {}) {
  const back = document.getElementById("nicknamePickerModal");
  const input = document.getElementById("nicknamePickerInput");
  const status = document.getElementById("nicknamePickerStatus");
  const okBtn = document.getElementById("nicknamePickerOk");
  const cancelBtn = document.getElementById("nicknamePickerCancel");
  const titleEl = document.getElementById("nicknamePickerTitle");
  const bodyEl = document.getElementById("nicknamePickerBody");
  if (!back || !input || !okBtn || !cancelBtn) return Promise.resolve(null);

  if (titleEl) titleEl.textContent = title || "Choose a nickname";
  if (bodyEl) bodyEl.innerHTML = body || "";
  input.value = normalizeHandleInput(initial);
  setHandleCheckStatus(status, "", "");
  this.bindHandleAvailability(input, status);
  back.classList.remove("hidden");

  return new Promise((resolve) => {
    const close = (value) => {
      back.classList.add("hidden");
      okBtn.onclick = cancelBtn.onclick = back.onclick = null;
      input.onkeydown = null;
      document.removeEventListener("keydown", onKey);
      resolve(value);
    };
    const submit = async () => {
      const handle = normalizeHandleInput(input.value);
      const localErr = validateHandleLocal(handle);
      if (localErr) {
        setHandleCheckStatus(status, "is-bad", localErr);
        input.focus();
        return;
      }
      okBtn.disabled = true;
      const data = input._runHandleCheck
        ? await input._runHandleCheck()
        : await this.checkHandleAvailable(handle);
      okBtn.disabled = false;
      if (!data.available) {
        setHandleCheckStatus(status, "is-bad", data.reason || NICKNAME_TAKEN_MSG);
        input.focus();
        return;
      }
      close(data.handle || handle);
    };
    const onKey = (e) => {
      if (e.key === "Escape") close(required ? null : (this.account?.handle || null));
      else if (e.key === "Enter") { e.preventDefault(); void submit(); }
    };
    okBtn.onclick = () => { void submit(); };
    cancelBtn.onclick = () => close(required ? null : (this.account?.handle || null));
    back.onclick = (e) => { if (e.target === back) close(required ? null : (this.account?.handle || null)); };
    input.onkeydown = (e) => { if (e.key === "Enter") { e.preventDefault(); void submit(); } };
    document.addEventListener("keydown", onKey);
    input.focus();
    input.select();
    if (input.value) void input._runHandleCheck?.();
  });
}

Game.prototype.show = function (id) { const el = document.getElementById(id); if (el) el.classList.remove("hidden"); }

Game.prototype.hide = function (id) { const el = document.getElementById(id); if (el) el.classList.add("hidden"); }

Game.prototype.updateSpellSpriteDevPanel = function () {
    updateSpellSpriteDevPanelVisibility(this);
    if (spellSpriteDevVisible(this)) refreshSpellSpriteDevFields();
  }

Game.prototype.panelVisible = function (id) {
    const el = document.getElementById(id);
    return !!(el && !el.classList.contains("hidden"));
  }

Game.prototype.matchmakerBack = function () {
    if (this._readyCheck) return;
    if (this.mmOverlayOpen()) {
      this.closeMmOverlay();
      return;
    }
    this.leaveMatchQueue();
    this.showFind();
  }

Game.prototype.historyDetailOpen = function () {
    const detail = document.getElementById("historyDetail");
    return !!(detail && !detail.classList.contains("hidden") && detail.innerHTML);
  }

Game.prototype.historyBackToList = function () {
    if (!this.historyDetailOpen()) return false;
    const detail = document.getElementById("historyDetail");
    const list = document.getElementById("historyList");
    const panelBack = document.getElementById("historyBack");
    detail.classList.add("hidden");
    detail.innerHTML = "";
    if (list) list.classList.remove("hidden");
    if (panelBack) panelBack.classList.remove("hidden");
    return true;
  }

Game.prototype.handleMenuEscape = function () {
    if (this._rebind) return false;

    const audioPanel = document.getElementById("audioPanel");
    if (audioPanel && !audioPanel.classList.contains("hidden")) {
      if (this._setAudioPanelOpen) this._setAudioPanelOpen(false);
      else audioPanel.classList.add("hidden");
      return true;
    }

    if (this.panelVisible("achievementsDialog")) {
      Sound.ui();
      this.closeAchievementsDialog();
      return true;
    }

    if (this.panelVisible("reportCenter")) {
      Sound.ui();
      this.closeReportCenter();
      return true;
    }

    if (this.isProfileExpanded()) {
      Sound.ui();
      this.closeProfile(false);
      return true;
    }

    if (this.state === "lobby" && this.panelVisible("lobby")) {
      Sound.ui();
      this.showMenu(this.menuLeaveOpts());
      return true;
    }

    if (this.state !== "menu") return false;

    if (this.historyDetailOpen()) {
      Sound.ui();
      this.historyBackToList();
      return true;
    }

    switch (this.homeView) {
      case "matchmaker":
        if (!this.panelVisible("matchmaker")) return false;
        if (this._readyCheck) return true;
        if (this.mmOverlayOpen()) { Sound.ui(); this.closeMmOverlay(); return true; }
        if (this._inMatchQueue) { Sound.ui(); this.leaveMatchQueue(); return true; }
        Sound.ui();
        this.showFind();
        return true;
      case "find":
        if (!this.panelVisible("findGame")) return false;
        Sound.ui();
        this.showHome();
        return true;
      case "solo":
        if (!this.panelVisible("soloSetup")) return false;
        Sound.ui();
        this.showHome();
        return true;
      case "keybinds":
        if (!this.panelVisible("keybinds")) return false;
        Sound.ui();
        this.keybindsBack();
        return true;
      case "history":
        if (!this.panelVisible("historyPanel")) return false;
        Sound.ui();
        this.showHome();
        return true;
      case "credits":
        if (!this.panelVisible("creditsPanel")) return false;
        Sound.ui();
        this.showHome();
        return true;
      case "spellbook":
        if (!this.panelVisible("spellbook")) return false;
        Sound.ui();
        this.spellbookBack();
        return true;
      case "learn":
        if (!this.panelVisible("learnPanel")) return false;
        Sound.ui();
        this.learnBack();
        return true;
      case "signin":
        if (!this.panelVisible("signInPanel")) return false;
        Sound.ui();
        this.showHome();
        return true;
      default:
        return false;
    }
  }

Game.prototype.hideAllPanels = function () {
    this.clearSpellBarTip();
    this.statusTipKey = null;
    window.resetShopPopoversPause?.();
    SpellPreview.hide();
    this.stopLearnPreviews();
    const panels = ["menu", "findGame", "matchmaker", "soloSetup", "keybinds", "signInPanel", "lobby", "shop", "reveal", "draft", "matchover", "banner", "bossIntro", "spellSpriteDev", "learnPanel", "spellbook", "historyPanel", "creditsPanel"];
    if (this.matchMode !== "sandbox") panels.push("sandboxHud");
    panels.forEach(i => this.hide(i));
    this.syncPatchNotesWidget(false);
    this.syncProfileWidget(false);
    this.syncMMWatchWidget(false);
  }

Game.prototype.sendSandboxCfg = function (opts) {
    if (this.matchMode !== "sandbox" || !this.net) return;
    const msg = { t: "sandbox" };
    if (opts.noCd !== undefined) msg.noCd = opts.noCd;
    if (opts.stationary !== undefined) msg.stationary = opts.stationary;
    if (opts.dummyDelta !== undefined) msg.dummyDelta = opts.dummyDelta;
    if (opts.dumbDelta !== undefined) msg.dumbDelta = opts.dumbDelta;
    if (opts.smartDelta !== undefined) msg.smartDelta = opts.smartDelta;
    if (opts.platformDelta !== undefined) msg.platformDelta = opts.platformDelta;
    if (opts.reset) msg.reset = opts.reset;
    if (opts.boss !== undefined) msg.boss = opts.boss;
    if (opts.previewBriefings) msg.previewBriefings = true;
    this.net.send(msg);
  }

Game.prototype.showSandboxBossBriefings = function (intros) {
    this.bossIntroPreview = true;
    this.sandboxBriefingIntros = intros || [];
    this.sandboxBriefingIndex = 0;
    this.renderSandboxBriefingPage();
    this.show("bossIntro");
    this.updateBossIntroReadyButton();
  }

Game.prototype.renderSandboxBriefingPage = function () {
    const intros = this.sandboxBriefingIntros || [];
    const intro = intros[this.sandboxBriefingIndex || 0];
    if (!intro) return;
    this.renderBossIntro(intro);
    this.syncBossIntroPager();
  }

Game.prototype.syncBossIntroPager = function () {
    const pager = document.getElementById("bossIntroPager");
    const label = document.getElementById("bossIntroPagerLabel");
    const prev = document.getElementById("bossIntroPrevBtn");
    const next = document.getElementById("bossIntroNextBtn");
    const intros = this.sandboxBriefingIntros || [];
    const idx = this.sandboxBriefingIndex || 0;
    if (pager) pager.classList.toggle("hidden", !this.bossIntroPreview || intros.length === 0);
    if (label && intros[idx]) {
      const name = intros[idx].name || pveBossName(intros[idx].id);
      label.textContent = `${name} · ${idx + 1} / ${intros.length}`;
    }
    if (prev) prev.disabled = idx <= 0;
    if (next) next.disabled = idx >= intros.length - 1;
  }

Game.prototype.stepSandboxBriefing = function (delta) {
    const intros = this.sandboxBriefingIntros || [];
    if (!this.bossIntroPreview || intros.length === 0) return;
    const next = Math.max(0, Math.min(intros.length - 1, (this.sandboxBriefingIndex || 0) + delta));
    if (next === this.sandboxBriefingIndex) return;
    this.sandboxBriefingIndex = next;
    this.renderSandboxBriefingPage();
  }

Game.prototype.closeBossIntroPreview = function () {
    this.bossIntroPreview = false;
    this.sandboxBriefingIntros = null;
    this.sandboxBriefingIndex = 0;
    this.hide("bossIntro");
    this.syncBossIntroPager();
    this.updateBossIntroReadyButton();
  }

const SANDBOX_PLATFORM_STEPS = [0.14, 0.3, 0.6, 0.8, 1];

Game.prototype.sandboxPlatformStepIndex = function () {
    const frac = this.sandboxPlatformFrac || 1;
    let best = 0;
    for (let i = 0; i < SANDBOX_PLATFORM_STEPS.length; i++) {
      if (Math.abs(SANDBOX_PLATFORM_STEPS[i] - frac) < Math.abs(SANDBOX_PLATFORM_STEPS[best] - frac)) best = i;
    }
    return best;
  }

Game.prototype.hasSandboxBossAccess = function () {
    if (isLocalDev()) return true;
    const role = this.account?.role;
    return role === "admin" || role === "game_master";
  }

Game.prototype.syncSandboxBossUI = function () {
    const hasAccess = this.matchMode === "sandbox" && this.hasSandboxBossAccess();
    const row = document.getElementById("sandboxBossRow");
    if (row) row.classList.toggle("hidden", !hasAccess);
    const briefingsBtn = document.getElementById("sandboxBossBriefingsBtn");
    if (briefingsBtn) {
      briefingsBtn.classList.toggle("hidden", !hasAccess);
      briefingsBtn.disabled = !this.isHost;
    }
    const sel = document.getElementById("sandboxBossSelect");
    if (sel) {
      if (sel.options.length <= 1) {
        for (const id of PVE_GAUNTLET) {
          const opt = document.createElement("option");
          opt.value = id;
          opt.textContent = pveBossName(id);
          sel.appendChild(opt);
        }
      }
      if (this.sandboxBossFight != null) sel.value = this.sandboxBossFight || "";
      sel.disabled = !this.isHost;
    }
  }

Game.prototype.syncSandboxCfgUI = function () {
    const maxEnemies = 4;
    const platN = document.getElementById("sandboxPlatformSize");
    const platP = document.getElementById("sandboxPlatformPlus");
    const platM = document.getElementById("sandboxPlatformMinus");
    const platIdx = this.sandboxPlatformStepIndex();
    if (platN) platN.textContent = `${Math.round((this.sandboxPlatformFrac || 1) * 100)}%`;
    if (platP) platP.disabled = platIdx >= SANDBOX_PLATFORM_STEPS.length - 1;
    if (platM) platM.disabled = platIdx <= 0;
    const smartN = document.getElementById("sandboxSmartCount");
    const smartP = document.getElementById("sandboxSmartPlus");
    const smartM = document.getElementById("sandboxSmartMinus");
    if (smartN) smartN.textContent = String(this.sandboxSmartCount);
    if (smartP) smartP.disabled = this.sandboxSmartCount >= maxEnemies;
    if (smartM) smartM.disabled = this.sandboxSmartCount <= 0;
    const dumbN = document.getElementById("sandboxDumbCount");
    const dumbP = document.getElementById("sandboxDumbPlus");
    const dumbM = document.getElementById("sandboxDumbMinus");
    if (dumbN) dumbN.textContent = String(this.sandboxDumbCount);
    if (dumbP) dumbP.disabled = this.sandboxDumbCount >= maxEnemies;
    if (dumbM) dumbM.disabled = this.sandboxDumbCount <= 0;
    const dummyN = document.getElementById("sandboxDummyCount");
    const dummyP = document.getElementById("sandboxDummyPlus");
    const dummyM = document.getElementById("sandboxDummyMinus");
    if (dummyN) dummyN.textContent = String(this.sandboxDummyCount);
    if (dummyP) dummyP.disabled = this.sandboxDummyCount >= 1;
    if (dummyM) dummyM.disabled = this.sandboxDummyCount <= 0;
    const st = document.getElementById("sandboxStationary");
    if (st) st.checked = this.sandboxStationary;
    const nc = document.getElementById("sandboxNoCD");
    if (nc) nc.checked = this.sandboxNoCD;
    const hb = document.getElementById("sandboxHitboxes");
    if (hb) hb.checked = this.showHitboxes;
    const spriteLink = document.getElementById("sandboxSpritePreviewLink");
    if (spriteLink) spriteLink.classList.toggle("hidden", !isLocalDev());
    this.syncSandboxBossUI();
  }

Game.prototype.applySandboxRoster = function (members) {
    if (!members) return;
    const keep = new Set(members.map(m => m.id));
    this.players = this.players.filter(p => {
      if (keep.has(p.id)) return true;
      delete this.playerById[p.id];
      return false;
    });
    for (const pw of members) {
      let p = this.playerById[pw.id];
      if (!p) {
        p = new Player(pw.color, pw.id === this.myId);
        p.id = pw.id;
        this.players.push(p);
        this.playerById[pw.id] = p;
      }
      p.name = pw.name;
      p.dummy = !!pw.dm;
      p.dumbEnemy = !!pw.de;
      p.isBot = !!pw.bot;
      p.botSkill = pw.bot ? normalizeBotSkill(pw.botSkill) : "";
      p.boss = pw.bs || "";
      if (p.boss) {
        p.colorName = pveBossName(p.boss);
        p.name = pw.name || p.colorName;
      }
      if (p.dummy) { p.robe = "#6b7280"; p.trim = "#d1d5db"; }
      p.team = pw.team || 0;
      p.alive = true;
    }
  }

Game.prototype.resetSandboxSessionStats = function () {
    this.sandboxLastHitAt = 0;
    this.sandboxActivity = null;
    this.renderSandboxActivity(null);
    this.sendSandboxCfg({ reset: "stats" });
  }

Game.prototype.onSandboxSync = function (msg) {
    this.sandboxNoCD = !!msg.noCd;
    this.sandboxStationary = !!msg.stationary;
    this.sandboxDummyCount = msg.dummyCount | 0;
    this.sandboxDumbCount = msg.dumbCount | 0;
    this.sandboxSmartCount = msg.smartCount | 0;
    const arenaSize = msg["platformFrac"];
    if (arenaSize != null && arenaSize > 0) {
      this.sandboxPlatformFrac = arenaSize;
    }
    if (msg.bossFight != null) this.sandboxBossFight = msg.bossFight;
    this.syncSandboxCfgUI();
    if (msg.players) this.applySandboxRoster(msg.players);
    this.applyKit(msg);
    const h = this.human();
    if (h && this.sandboxNoCD && h.cd) {
      for (const id of Object.keys(h.cd)) h.cd[id] = 0;
    }
    if (this.sandboxShopOpen) {
      this.ensureShopDom();
      const data = {
        round: this.roundNumber, gold: msg.gold, sp: msg.sp,
        loadout: msg.loadout || {}, committed: msg.committed || {},
        items: msg.items || {},
      };
      this.renderShopUI(data, (kind, id) => { if (this.net) this.net.send({ t: "buy", kind, id }); Sound.ui(); });
    }
    if (this.simReady && h) wsimReconcile({ x: h.x, y: h.y, vx: 0, vy: 0, alive: true, falling: false, stun: false, knockT: 0, root: false, freeze: false, channel: false, rush: false, invis: false, slow: false, slowMul: 1, moveMult: h.moveMult || 1, mindLash: 0, mindCtrl: 0, face: h.facing, aim: h.aim ?? h.facing, pending: "", channelSpell: "" });
  }

Game.prototype.updateSandboxShopBtn = function () {
    this.ensureUIEls();
    const els = this._uiEls;
    const btn = els.sandboxShopBtn;
    if (btn) {
      btn.textContent = this.sandboxShopOpen ? "✕ Close spellbook" : "📖 Spellbook (B)";
      btn.setAttribute("aria-label", this.sandboxShopOpen ? "Close spellbook" : "Open spellbook (B)");
      btn.disabled = !!this.sandboxDraftOpen;
    }
    const draftBtn = els.sandboxDraftBtn;
    if (draftBtn) {
      draftBtn.disabled = !!this.sandboxDraftOpen || !!this.sandboxShopOpen;
    }
    const cfg = els.sandboxCfg;
    if (cfg) cfg.classList.toggle("hidden", !(this.matchMode === "sandbox" && this.state === "playing") || !!this.sandboxDraftOpen);
  }

Game.prototype.updateSandboxCfgUI = function () {
    this.updateSandboxShopBtn();
    this.syncSandboxCfgUI();
  }

Game.prototype.onQueueStatus = function (msg) {
    if (!this._inMatchQueue) return;
    if (msg.rounds > 0) this.mmRounds = msg.rounds;
    if (msg.startGold != null) this.mmStartGold = msg.startGold;
    this.updateMmFixedSettings();
    if (this._readyCheck) this.hideReadyCheck();
    this.updateMatchQueueUI(msg);
  }

Game.prototype.showMenu = function (opts = {}) {
    this.cancelLobbyStartCountdown(true);
    this.leaveMatchQueue();
    this._intentionalClose = true;
    this._voidSoundManual = false;
    Sound.stopVoidIndicator();
    Sound.stopAllFirewallLoops();
    this.spectating = false;
    this.clearRoundSpectate();
    this.spectateWatchId = null;
    this.spectateWatchPending = null;
    this.hideSpectateHud();
    this.closeSandboxShop();
    this.sandboxNoCD = false;
    this.sandboxStationary = false;
    this.sandboxDummyCount = 0;
    this.sandboxDumbCount = 0;
    this.sandboxSmartCount = 0;
    this.sandboxPlatformFrac = 1;
    this.sandboxBossFight = "";
    this.bossIntroPreview = false;
    this.sandboxBriefingIntros = null;
    this.sandboxBriefingIndex = 0;
    this.hide("bossIntro");
    this.sandboxLastHitAt = 0;
    this.sandboxActivity = null;
    this.matchMode = "normal";
    if (this.net) { this.net.close(); this.net = null; }
    this.mode = "local";
    this.state = "menu";
    this.maxRadius = CFG.worldRadius;
    this.platformRadius = this.maxRadius;
    this.players = []; this.projectiles = []; this.mines = []; this.sigils = []; this.healpods = []; this.blizzards = []; this.firewalls = []; this.hellrips = []; this.stickymines = []; this.icewalls = []; this.voidglass = []; this.nullSphereErupts = []; this.bossBeams = []; this.particles = []; this.snaps = [];
    this.shockwaves = []; this.beams = []; this.armPops = []; this.spellSpritePops = []; this.meteorCraters = []; this.floorBurns = []; this.bloodStains = []; this.plagueStains = []; this.frostStains = []; this.meteorNukeClouds = []; this.meteorNukeSwamps = []; this.meteorNukeFuses = [];
    this.clearCreds();
    this.clearLobbyInviteURL();
    this._fromMatchmaking = false;
    this.onQueueInviteEnd();
    const returnSolo = opts.toSolo || this._fromPractice;
    this._fromPractice = false;
    this.hideAllPanels();
    this.updateSpellSpriteDevPanel();
    if (returnSolo) this.showSolo();
    else if (opts.toMatchmaker) this.showMatchmaker();
    else if (opts.toFind) this.showFind();
    else this.showHome();
    this.ensureMenuNet();
  }

const PATCH_NOTES_MIN_KEY = "wlkPatchNotesMin";

Game.prototype.isPatchNotesMinimized = function () {
  try { return localStorage.getItem(PATCH_NOTES_MIN_KEY) === "1"; } catch (e) { return false; }
};

Game.prototype.setPatchNotesMinimized = function (min) {
  const widget = document.getElementById("patchNotesWidget");
  if (!widget) return;
  widget.classList.toggle("patch-notes-widget-minimized", min);
  try { localStorage.setItem(PATCH_NOTES_MIN_KEY, min ? "1" : "0"); } catch (e) { /* ignore */ }
  const btn = document.getElementById("patchNotesMinimize");
  if (btn) {
    btn.textContent = min ? "+" : "−";
    btn.setAttribute("aria-label", min ? "Expand patch notes" : "Minimize patch notes");
  }
};

Game.prototype.togglePatchNotesMinimized = function () {
  const widget = document.getElementById("patchNotesWidget");
  if (!widget) return;
  const min = !widget.classList.contains("patch-notes-widget-minimized");
  this.setPatchNotesMinimized(min);
};

const PRE_ALPHA_MIN_KEY = "wlkPreAlphaMin";

Game.prototype.isPreAlphaMinimized = function () {
  try { return localStorage.getItem(PRE_ALPHA_MIN_KEY) === "1"; } catch (e) { return false; }
};

Game.prototype.setPreAlphaMinimized = function (min) {
  const el = document.getElementById("preAlphaNotice");
  if (!el) return;
  el.classList.toggle("pre-alpha-notice-minimized", min);
  try { localStorage.setItem(PRE_ALPHA_MIN_KEY, min ? "1" : "0"); } catch (e) { /* ignore */ }
  const btn = document.getElementById("preAlphaMinimize");
  if (btn) {
    btn.textContent = min ? "+" : "−";
    btn.setAttribute("aria-label", min ? "Expand welcome" : "Minimize welcome");
  }
};

Game.prototype.togglePreAlphaMinimized = function () {
  const el = document.getElementById("preAlphaNotice");
  if (!el) return;
  this.setPreAlphaMinimized(!el.classList.contains("pre-alpha-notice-minimized"));
};

Game.prototype.syncPatchNotesWidget = function (visible) {
  const widget = document.getElementById("patchNotesWidget");
  if (!widget) return;
  widget.classList.toggle("hidden", !visible);
  if (!visible) {
    SpellPreview.hide();
    return;
  }
  const body = document.getElementById("patchNotesBody");
  if (body && !body.children.length) {
    const render = () => {
      const current = body.querySelector(".pn-version-select")?.value;
      renderPatchNotes(body, current);
    };
    render();
    this.ensureCatalog?.().then(render);
  }
  this.setPatchNotesMinimized(this.isPatchNotesMinimized());
};

Game.prototype.syncMMWatchWidget = function (visible) {
  const widget = document.getElementById("mmWatchWidget");
  if (!widget) return;
  const show = visible && this.homeAuthReady && !this.shouldShowAuthWelcome();
  widget.classList.toggle("hidden", !show);
  if (show) this.startMMPoll();
  else this.stopMMPoll();
};

Game.prototype.showHome = function () {
    this.homeView = "home";
    this.stopRoomPoll();
    this.cancelRebind();
    this.hidePing();
    Sound.stopCreditPreview();
    SpellPreview.hide();
    this.stopLearnPreviews();
    this.hide("findGame"); this.hide("matchmaker"); this.hide("soloSetup"); this.hide("keybinds"); this.hide("signInPanel");
    this.hide("historyPanel"); this.hide("creditsPanel"); this.hide("spellbook"); this.hide("learnPanel");
    this.closeReportCenter();
    this.show("menu");
    this.applyHomeMenuLayout();
    this.syncPatchNotesWidget(true);
    this.syncMMWatchWidget(true);
    this.syncProfileWidget(true);
    this.updateMmQueueCooldownUI();
    this.syncMusic();
    void this.refreshActiveGame();
    this.ensureMenuNet();
    this.syncQueueInviteUI();
  }

Game.prototype.authAvailable = function () {
    return !!(this.googleEnabled || this.discordEnabled);
  }

Game.prototype.shouldShowAuthWelcome = function () {
    return !this.account && this.authAvailable() && !this.homeGuestMode;
  }

Game.prototype.applyHomeMenuLayout = function () {
    if (this.state !== "menu" || this.homeView !== "home") return;
    const menu = document.getElementById("menu");
    const boot = document.getElementById("homeBoot");
    const welcome = document.getElementById("authWelcome");
    const main = document.getElementById("homeMain");
    if (!menu) return;

    if (!this.homeAuthReady) {
      menu.classList.add("home-booting", "home-layout-boot");
      menu.classList.remove("home-layout-welcome", "home-layout-main");
      if (boot) {
        boot.classList.remove("hidden");
        boot.setAttribute("aria-busy", "true");
      }
      if (welcome) welcome.classList.add("hidden");
      if (main) main.classList.add("hidden");
      return;
    }

    menu.classList.remove("home-booting", "home-layout-boot");
    if (boot) {
      boot.classList.add("hidden");
      boot.setAttribute("aria-busy", "false");
    }

    const showWelcome = this.shouldShowAuthWelcome();
    menu.classList.toggle("home-layout-welcome", showWelcome);
    menu.classList.toggle("home-layout-main", !showWelcome);
    if (welcome) welcome.classList.toggle("hidden", !showWelcome);
    if (main) main.classList.toggle("hidden", showWelcome);
    this.syncQueueInviteUI();
    this.syncMMWatchWidget(this.state === "menu" && this.homeView === "home");
  }

Game.prototype.finishHomeAuthBoot = function () {
    this.homeAuthReady = true;
    this.applyHomeMenuLayout();
    if (this.state === "menu" && this.homeView === "home") {
      this.syncProfileWidget(true);
    }
    this.syncQueueInviteUI();
  }

Game.prototype.dismissAuthWelcome = function () {
    this.homeGuestMode = true;
    this.applyHomeMenuLayout();
    this.renderAccount();
    this.syncQueueInviteUI();
  }

Game.prototype.choosePlayAsGuest = function () {
    Sound.ui();
    this.dismissAuthWelcome();
    const name = document.getElementById("nameInput");
    if (name) name.focus();
  }

Game.prototype.chooseSignInFromWelcome = function () {
    Sound.ui();
    this.showSignIn();
  }

Game.prototype.showSignIn = function () {
    this.homeView = "signin";
    this.stopRoomPoll();
    SpellPreview.hide();
    this.stopLearnPreviews();
    this.hide("menu"); this.hide("findGame"); this.hide("matchmaker"); this.hide("soloSetup"); this.hide("signInPanel"); this.hide("keybinds");
    this.hide("historyPanel"); this.hide("creditsPanel"); this.hide("spellbook"); this.hide("learnPanel");
    this.closeReportCenter();
    this.renderSignInPanel();
    const hint = document.getElementById("signInPanelHint");
    if (hint) {
      const methods = [];
      if (this.discordEnabled) methods.push("Discord");
      if (this.googleEnabled) methods.push("Google");
      hint.textContent = methods.length
        ? `Sign in with ${methods.length > 1 ? methods.slice(0, -1).join(", ") + " or " + methods[methods.length - 1] : methods[0]} to save your progress.`
        : "Sign-in is unavailable right now.";
    }
    this.show("signInPanel");
    this.syncQueueInviteUI();
    this.syncPatchNotesWidget(false);
    this.syncProfileWidget(false);
    this.syncMusic();
  }

Game.prototype.showFind = function () {
    this.homeView = "find";
    this.closeMmOverlay();
    SpellPreview.hide();
    this.stopLearnPreviews();
    this.hide("menu"); this.hide("matchmaker"); this.hide("soloSetup"); this.hide("keybinds"); this.hide("signInPanel");
    this.hide("historyPanel"); this.hide("creditsPanel"); this.hide("spellbook"); this.hide("learnPanel");
    this.closeReportCenter();
    this.show("findGame");
    this.syncMMWatchWidget(false);
    this.syncPatchNotesWidget(false);
    this.syncProfileWidget(false);
    this.showFindError("");
    this.startRoomPoll();
    this.syncMusic();
    void this.refreshActiveGame();
  }

Game.prototype.showMatchmaker = function () {
    this.homeView = "matchmaker";
    this.stopRoomPoll();
    SpellPreview.hide();
    this.stopLearnPreviews();
    this.hide("menu"); this.hide("findGame"); this.hide("soloSetup"); this.hide("keybinds"); this.hide("signInPanel");
    this.hide("historyPanel"); this.hide("creditsPanel"); this.hide("spellbook"); this.hide("learnPanel");
    this.closeReportCenter();
    this.closeMmOverlay();
    this.hideReadyCheck();
    this.hideQueueFillModal();
    this.show("matchmaker");
    this.syncMMWatchWidget(false);
    this.syncPatchNotesWidget(false);
    this.syncProfileWidget(false);
    this.updateMmQueueCooldownUI();
    this.updateMmFixedSettings();
    this.fetchMatchmakerConfig();
    this.updateMatchQueueUI(null);
    this.syncMmFormatUI();
    this.updateMmQueueCooldownUI();
    this.syncMusic();
  }

Game.prototype.showSolo = function () {
    this.homeView = "solo";
    this.stopRoomPoll();
    SpellPreview.hide();
    this.stopLearnPreviews();
    this.hide("menu"); this.hide("findGame"); this.hide("matchmaker"); this.hide("keybinds"); this.hide("signInPanel");
    this.hide("historyPanel"); this.hide("creditsPanel"); this.hide("spellbook"); this.hide("learnPanel");
    this.show("soloSetup");
    this.buildMenu();
    this.buildBotSkillSeg();
    this.syncPatchNotesWidget(false);
    this.syncProfileWidget(false);
  }

Game.prototype.showKeybinds = function (returnTo = "home") {
    this._keybindsReturn = returnTo;
    this.homeView = "keybinds";
    this.stopRoomPoll();
    SpellPreview.hide();
    this.stopLearnPreviews();
    this.hide("menu"); this.hide("findGame"); this.hide("matchmaker"); this.hide("soloSetup"); this.hide("signInPanel");
    this.hide("historyPanel"); this.hide("creditsPanel"); this.hide("spellbook"); this.hide("learnPanel");
    this.renderKeybinds();
    this.show("keybinds");
    this.syncPatchNotesWidget(false);
    this.syncProfileWidget(false);
  }

Game.prototype.keybindsBack = function () {
    this.cancelRebind();
    const ret = this._keybindsReturn || "home";
    this.hide("keybinds");
    if (ret === "learn") this.showLearn();
    else this.showHome();
  }

Game.prototype.showHistory = function () {
    this.homeView = "history";
    this.stopRoomPoll();
    SpellPreview.hide();
    this.stopLearnPreviews();
    this.hide("menu"); this.hide("findGame"); this.hide("matchmaker"); this.hide("soloSetup"); this.hide("signInPanel");
    this.hide("keybinds"); this.hide("creditsPanel"); this.hide("spellbook"); this.hide("learnPanel");
    this.show("historyPanel");
    this.syncPatchNotesWidget(false);
    this.syncProfileWidget(false);
    this.showHistoryError("");
    this.fetchHistory();
  }

Game.prototype.buildAudioCreditsList = function () {
    const ul = document.getElementById("audioCreditsList");
    if (!ul || ul.dataset.built) return;
    ul.dataset.built = "1";
    Sound.setCreditPreviewEndCb(() => this.updateAudioCreditsPlayButtons());
    const hint = document.getElementById("creditsPanelHint");
    if (hint) {
      hint.innerHTML = isLocalDev()
        ? 'Music and sound effects used in Warlocks. <b>▶ Play</b> previews each clip at its in-game <code>FILE_GAIN</code> (edit <code>MUSIC_TRACK_GAIN</code> in <code>game.js</code>). Only one preview at a time.'
        : "Music and sound effects used in Warlocks. Thank you to the artists below.";
    }
    for (const entry of AUDIO_CREDITS) {
      const li = document.createElement("li");
      li.className = "audio-credit";
      const title = document.createElement("div");
      title.className = "audio-credit-file";
      title.textContent = entry.file;
      li.appendChild(title);
      if (entry.path) {
        const row = document.createElement("div");
        row.className = "audio-credit-play";
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "audio-credit-play-btn";
        btn.dataset.creditPath = entry.path;
        btn.textContent = "▶ Play";
        btn.onclick = () => {
          Sound.resume();
          Sound.ui();
          Sound.toggleCreditPreview(entry.path, entry.loop !== false);
          this.updateAudioCreditsPlayButtons();
        };
        row.appendChild(btn);
        if (isLocalDev()) {
          const gain = document.createElement("span");
          gain.className = "audio-credit-gain";
          gain.dataset.creditGain = entry.path;
          row.appendChild(gain);
        }
        li.appendChild(row);
      }
      const artist = document.createElement("div");
      artist.className = "audio-credit-artist";
      artist.innerHTML = entry.artist;
      li.appendChild(artist);
      if (entry.lic) {
        const lic = document.createElement("div");
        lic.className = "audio-credit-lic";
        lic.innerHTML = entry.lic;
        li.appendChild(lic);
      }
      if (entry.src) {
        const a = document.createElement("a");
        a.className = "audio-credit-src";
        a.href = entry.src;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.textContent = "Source on YouTube";
        li.appendChild(a);
      }
      ul.appendChild(li);
    }
    this.updateAudioCreditsPlayButtons();
  }

Game.prototype.updateAudioCreditsPlayButtons = function () {
    const playing = Sound.creditPreviewPath();
    document.querySelectorAll(".audio-credit-play-btn").forEach(btn => {
      const on = btn.dataset.creditPath === playing;
      btn.textContent = on ? "■ Stop" : "▶ Play";
      btn.classList.toggle("is-playing", on);
    });
    if (isLocalDev()) {
      document.querySelectorAll(".audio-credit-gain").forEach(el => {
        const p = el.dataset.creditGain;
        if (!p) return;
        el.textContent = `FILE_GAIN ${Sound.fileGain(p)}`;
      });
    }
  }

Game.prototype.showCredits = function () {
    this.homeView = "credits";
    this.stopRoomPoll();
    Sound.stopCombatMusic();
    this.buildAudioCreditsList();
    SpellPreview.hide();
    this.stopLearnPreviews();
    this.hide("menu"); this.hide("findGame"); this.hide("matchmaker"); this.hide("soloSetup"); this.hide("signInPanel");
    this.hide("keybinds"); this.hide("historyPanel"); this.hide("spellbook"); this.hide("learnPanel");
    this.show("creditsPanel");
    this.syncPatchNotesWidget(false);
    this.syncProfileWidget(false);
  }

Game.prototype.showHistoryError = function (msg) {
    const e = document.getElementById("historyError");
    if (e) e.textContent = msg || "";
  }

Game.prototype.setupReportCenter = function ($) {
    const backdrop = $("reportCenter");
    const openers = [
      ["feedbackBtn", null],
      ["lobbyReportBtn", { source: "lobby" }],
      ["shopReportBtn", { source: "shop" }],
      ["revealReportBtn", { source: "reveal" }],
      ["draftReportBtn", { source: "draft" }],
      ["matchoverReportBtn", { source: "matchover" }],
    ];
    for (const [id, ctx] of openers) {
      const el = $(id);
      if (el) el.onclick = () => { Sound.ui(); this.openReportCenter(ctx || undefined); };
    }
    if ($("reportCancel")) $("reportCancel").onclick = () => { Sound.ui(); this.closeReportCenter(); };
    if ($("reportSubmit")) $("reportSubmit").onclick = () => { Sound.ui(); this.submitReport(); };
    if (backdrop) {
      backdrop.addEventListener("click", (e) => {
        if (e.target === backdrop) { Sound.ui(); this.closeReportCenter(); }
      });
    }
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && backdrop && !backdrop.classList.contains("hidden")) {
        this.closeReportCenter();
      }
    });
  }

Game.prototype.reportGameContext = function (override) {
    const o = override || this._reportOverride || {};
    const code = (o.gameId || this.creds?.code || this.lobby?.code || document.getElementById("lobbyCode")?.textContent || "").trim().toUpperCase();
    const gameId = code && code !== "----" ? code : "";
    const matchId = o.matchId != null ? o.matchId : null;
    let source = o.source || "menu";
    if (!o.source) {
      if (this.state === "lobby") source = "lobby";
      else if (this.state === "matchover") source = "matchover";
      else if (this.state === "shop" && !document.getElementById("reveal")?.classList.contains("hidden")) source = "reveal";
      else if (this.state === "shop" && !document.getElementById("draft")?.classList.contains("hidden")) source = "draft";
      else if (this.state === "shop") source = "shop";
      else if (this.state === "playing" || this.state === "countdown" || this.state === "roundover") source = "playing";
      else if (this.state === "menu") source = "menu";
    }
    return {
      gameId,
      matchId,
      source,
      context: {
        source,
        state: this.state,
        round: this.roundNumber || 0,
        mode: this.mode,
        matchMode: this.matchMode || "",
        pingMs: this.pingMs ? Math.round(this.pingMs) : 0,
        build: typeof window.WLK_V === "string" ? window.WLK_V : "",
      },
    };
  }

Game.prototype.openReportCenter = function (override) {
    this._reportOverride = override || null;
    this._reportCategory = "spells";
    this._reportTags = new Set();
    const backdrop = document.getElementById("reportCenter");
    const thanks = document.getElementById("reportThanks");
    const err = document.getElementById("reportError");
    const actions = document.querySelector(".report-actions");
    if (thanks) thanks.classList.add("hidden");
    if (err) err.textContent = "";
    if (actions) actions.classList.remove("hidden");
    const submit = document.getElementById("reportSubmit");
    if (submit) { submit.disabled = false; submit.textContent = "Send report"; }
    this.renderReportCenter();
    if (backdrop) backdrop.classList.remove("hidden");
  }

Game.prototype.closeReportCenter = function () {
    this._reportOverride = null;
    const backdrop = document.getElementById("reportCenter");
    if (backdrop) backdrop.classList.add("hidden");
  }

Game.prototype.renderReportCenter = function () {
    const ctx = this.reportGameContext();
    const ctxEl = document.getElementById("reportGameCtx");
    if (ctxEl) {
      const parts = [];
      if (ctx.gameId) parts.push(`Game: <b>${escapeHtml(ctx.gameId)}</b>`);
      if (ctx.matchId != null) parts.push(`Match #${ctx.matchId}`);
      if (parts.length) {
        ctxEl.innerHTML = parts.join(" · ");
        ctxEl.classList.remove("hidden");
      } else {
        ctxEl.textContent = "";
        ctxEl.classList.add("hidden");
      }
    }
    const cats = document.getElementById("reportCategories");
    if (cats) {
      cats.innerHTML = REPORT_CAT_ORDER.map(id => {
        const c = REPORT_CATEGORIES[id];
        return `<button type="button" class="report-cat-btn ${id === this._reportCategory ? "active" : ""}" data-cat="${id}">${escapeHtml(c.label)}</button>`;
      }).join("");
      cats.querySelectorAll(".report-cat-btn").forEach(btn => {
        btn.onclick = () => {
          Sound.ui();
          this._reportCategory = btn.dataset.cat;
          this._reportTags = new Set();
          this.renderReportCenter();
        };
      });
    }
    const form = document.getElementById("reportForm");
    const cat = REPORT_CATEGORIES[this._reportCategory];
    if (!form || !cat) return;
    let html = `<p class="lobby-hint">${escapeHtml(cat.hint)}</p>`;
    if (cat.spellSelect) {
      const opts = SPELL_ORDER.map(id => SPELLS[id]).filter(Boolean)
        .sort((a, b) => a.name.localeCompare(b.name));
      html += `<label for="reportSpell">Spell</label><select id="reportSpell" class="text-input">` +
        `<option value="">— Select spell —</option>` +
        opts.map(s => `<option value="${escapeHtml(s.id)}">${escapeHtml(s.fallbackIcon)} ${escapeHtml(s.name)}</option>`).join("") +
        `</select>`;
    }
    if (cat.tags.length) {
      html += `<label>Quick tags <span class="report-tag-hint">(toggle any that apply)</span></label>` +
        `<div class="report-tags" id="reportTags">` +
        cat.tags.map(t =>
          `<button type="button" class="report-tag ${this._reportTags.has(t.id) ? "on" : ""}" data-tag="${escapeHtml(t.id)}">${escapeHtml(t.label)}</button>`
        ).join("") + `</div>`;
    }
    html += `<label for="reportDetails">Details</label>` +
      `<textarea id="reportDetails" class="text-input" maxlength="4000" placeholder="What happened? Steps to reproduce help us fix bugs faster."></textarea>`;
    form.innerHTML = html;
    form.querySelectorAll(".report-tag").forEach(btn => {
      btn.onclick = () => {
        Sound.ui();
        const id = btn.dataset.tag;
        if (this._reportTags.has(id)) this._reportTags.delete(id);
        else this._reportTags.add(id);
        btn.classList.toggle("on", this._reportTags.has(id));
      };
    });
  }

Game.prototype.submitReport = async function () {
    const errEl = document.getElementById("reportError");
    const setErr = (m) => { if (errEl) errEl.textContent = m || ""; };
    setErr("");
    const cat = this._reportCategory;
    const details = (document.getElementById("reportDetails")?.value || "").trim();
    const tags = [...this._reportTags];
    const spellEl = document.getElementById("reportSpell");
    const spellId = spellEl ? spellEl.value : "";
    if (cat === "other" && !details) { setErr("Please describe your feedback."); return; }
    if (cat !== "other" && !details && !tags.length) { setErr("Add details or select at least one tag."); return; }
    if (cat === "spells" && !spellId && !details) { setErr("Select a spell or describe the issue."); return; }

    const ctx = this.reportGameContext();
    const nameInput = document.getElementById("nameInput");
    const reporter = (this.account?.handle || nameInput?.value || "").trim();
    const payload = {
      category: cat,
      details,
      tags,
      reporter,
      gameId: ctx.gameId,
      matchId: ctx.matchId,
      context: ctx.context,
    };
    if (spellId) payload.spellId = spellId;

    const submit = document.getElementById("reportSubmit");
    if (submit) { submit.disabled = true; submit.textContent = "Sending…"; }
    try {
      const res = await fetch("/reports", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        credentials: "same-origin",
      });
      if (!res.ok) {
        const msg = res.status === 400 ? "Check your report and try again." : "Couldn't send report — try again later.";
        setErr(msg);
        if (submit) { submit.disabled = false; submit.textContent = "Send report"; }
        return;
      }
      const thanks = document.getElementById("reportThanks");
      const actions = document.querySelector(".report-actions");
      if (actions) actions.classList.add("hidden");
      if (thanks) thanks.classList.remove("hidden");
      track("report_sent", { category: cat, tags: tags.length, has_game: !!ctx.gameId });
      setTimeout(() => this.closeReportCenter(), 2200);
    } catch (e) {
      setErr("Couldn't reach the server.");
      if (submit) { submit.disabled = false; submit.textContent = "Send report"; }
    }
  }

Game.prototype.loadAccount = async function () {
    this.account = null;
    this.clearAchievementCache();
    this.googleEnabled = false;
    this.discordEnabled = false;
    try {
      const [meRes] = await Promise.all([
        fetch("/auth/me", { cache: "no-store" }),
        this.loadAlphaConfig(),
      ]);
      if (meRes.ok) {
        const data = await meRes.json();
        this.account = (data && data.user) || null;
        this.googleEnabled = !!(data && data.google);
        this.discordEnabled = !!(data && data.discord);
      }
    } catch (e) { /* offline / disabled: stay guest */ }
    this.syncSandboxBossUI();
    if (this.isAlphaAdmin() && this._alphaScheduledShown) {
      this.syncAlphaScheduledSplash(false);
      this.show("menu");
    }
    await this.refreshActiveGame();
    this.finishHomeAuthBoot();
    this.renderAccount();
    if (this.account) void this.fetchProfileTitles();
    await this.maybeClaimGuestNickname();
    if (this.panelVisible("achievementsDialog")) void this.fetchAchievements();
  }

Game.prototype.storeSignInNickname = function () {
    const nameInput = document.getElementById("nameInput");
    const nick = (nameInput?.value || "").trim();
    try {
      if (nick) sessionStorage.setItem("warlock_signin_nick", nick);
      else sessionStorage.removeItem("warlock_signin_nick");
    } catch (e) { /* private browsing */ }
  }

Game.prototype.maybeClaimGuestNickname = async function () {
    if (!this.account || this.account.handleLocked) return;
    let guestNick = "";
    try {
      guestNick = normalizeHandleInput(sessionStorage.getItem("warlock_signin_nick"));
      sessionStorage.removeItem("warlock_signin_nick");
    } catch (e) { /* ignore */ }
    if (!guestNick || guestNick === this.account.handle) return;

    const keep = await showConfirm({
      title: "Keep your nickname?",
      body: `You were playing as <b>${escapeHtml(guestNick)}</b>. Keep this as your permanent nickname?`,
      okText: "Keep nickname",
      cancelText: "Choose another",
    });
    if (keep) {
      const data = await this.checkHandleAvailable(guestNick);
      if (data.available) {
        await this.saveHandle(guestNick);
        return;
      }
      const picked = await this.showNicknamePicker({
        title: "Nickname taken",
        body: `<b>${escapeHtml(guestNick)}</b> is already taken. Choose a different nickname.`,
        initial: guestNick,
        required: true,
      });
      if (picked) await this.saveHandle(picked);
      return;
    }
    const picked = await this.showNicknamePicker({
      title: "Choose a nickname",
      body: "Pick a permanent nickname for your account. Letters and numbers only.",
      initial: "",
      required: false,
    });
    if (picked) await this.saveHandle(picked);
  }

Game.prototype.refreshActiveGame = async function () {
    if (!this.account) {
      this.activeGame = null;
      this.renderActiveGame();
      return;
    }
    try {
      const res = await fetch("/game/active", { cache: "no-store", credentials: "same-origin" });
      if (res.ok) {
        const data = await res.json();
        this.activeGame = (data && data.code) ? { code: data.code } : null;
      } else {
        this.activeGame = null;
      }
    } catch (e) {
      this.activeGame = null;
    }
    this.renderActiveGame();
  }

Game.prototype.renderActiveGame = function () {
    const active = !!(this.account && this.activeGame && this.activeGame.code);
    const code = active ? this.activeGame.code : "";
    const setCard = (cardId, codeId, show) => {
      const card = document.getElementById(cardId);
      const codeEl = document.getElementById(codeId);
      if (card) card.classList.toggle("hidden", !show);
      if (codeEl) codeEl.textContent = code;
    };
    setCard("activeGameCard", "activeGameCode", active);
    setCard("activeGameCardFind", "activeGameCodeFind", active);
    const goOnlineBtn = document.getElementById("goOnlineBtn");
    if (goOnlineBtn) goOnlineBtn.classList.toggle("hidden", active);
    const goSoloBtn = document.getElementById("goSoloBtn");
    if (goSoloBtn) goSoloBtn.classList.toggle("hidden", active);
    const goSandboxBtn = document.getElementById("goSandboxBtn");
    if (goSandboxBtn) goSandboxBtn.classList.toggle("hidden", active);
    const findModes = document.getElementById("findOnlineModes");
    if (findModes) findModes.classList.toggle("hidden", active);
  }

Game.prototype.renderSignInPanel = function () {
    const oauth = document.getElementById("signInOAuth");
    const googleBtn = document.getElementById("signInGoogleBtn");
    const discordBtn = document.getElementById("signInDiscordBtn");
    const showGoogle = !!this.googleEnabled;
    const showDiscord = !!this.discordEnabled;
    const showOAuth = showGoogle || showDiscord;
    if (oauth) oauth.classList.toggle("hidden", !showOAuth);
    if (discordBtn) discordBtn.classList.toggle("hidden", !showDiscord);
    if (googleBtn) googleBtn.classList.toggle("hidden", !showGoogle);
  }

Game.prototype.renderAccount = function () {
    const box = document.getElementById("accountBox");
    const guestLink = document.getElementById("guestSignInLink");
    const nameField = document.getElementById("nameInputField");
    const name = document.getElementById("nameInput");
    if (!box || !guestLink) return;
    if (this.account) {
      document.getElementById("accountHandle").textContent = this.account.handle || "";
      const av = document.getElementById("accountAvatar");
      if (this.account.avatar) { av.src = this.account.avatar; av.classList.remove("hidden"); }
      else av.classList.add("hidden");
      box.classList.remove("hidden");
      guestLink.classList.add("hidden");
      if (nameField) nameField.classList.add("hidden");
      if (name) {
        name.value = this.account.handle || "";
        this.saveName();
      }
    } else {
      box.classList.add("hidden");
      if (nameField) nameField.classList.remove("hidden");
      if (name) {
        name.disabled = false;
        name.classList.remove("locked");
      }
      const showGuestLink = this.authAvailable() && this.homeGuestMode;
      guestLink.classList.toggle("hidden", !showGuestLink);
    }
    this.renderSignInPanel();
    this.applyHomeMenuLayout();
    this.renderActiveGame();
    this.renderProfileChip();
    if (this.isProfileExpanded()) {
      this.renderProfileStats(null);
      void this.fetchProfileStats();
    }
  }

Game.prototype.saveHandle = async function (requested) {
    if (!this.account) return;
    if (this.account.handleLocked) return;
    const want = (requested || "").trim();
    const name = document.getElementById("nameInput");
    if (!want) { if (name) name.value = this.account.handle; return; } // don't allow blank
    if (want === this.account.handle) return;
    try {
      const res = await fetch("/auth/handle", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ handle: want }),
      });
      if (res.status === 403) {
        this.showMenuError(NICKNAME_LOCKED_MSG);
        this.account.handleLocked = true;
        this.renderAccount();
        return;
      }
      if (res.status === 409) {
        this.showMenuError(NICKNAME_TAKEN_MSG);
        if (name) name.value = this.account.handle;
        return;
      }
      if (!res.ok) {
        if (name) name.value = this.account.handle;
        return;
      }
      const data = await res.json();
      this.account.handle = data.handle;
      this.account.handleLocked = data.handleLocked !== false;
      if (name) name.value = data.handle; // reflect server-side sanitization
      document.getElementById("accountHandle").textContent = data.handle;
      this.renderAccount();
      this.saveName();
    } catch (e) { /* offline: leave as-is */ }
  }

Game.prototype.fetchHistory = async function () {
    const list = document.getElementById("historyList");
    const detail = document.getElementById("historyDetail");
    if (detail) { detail.classList.add("hidden"); detail.innerHTML = ""; }
    const panelBack = document.getElementById("historyBack");
    if (panelBack) panelBack.classList.remove("hidden"); // list view always shows the panel "Back"
    if (!list) return;
    list.classList.remove("hidden");
    list.innerHTML = `<div class="room-empty">Loading…</div>`;
    let matches;
    try {
      const res = await fetch("/matches?limit=50", { cache: "no-store" });
      if (!res.ok) throw new Error("http " + res.status);
      matches = await res.json();
    } catch (e) {
      list.innerHTML = "";
      this.showHistoryError("Couldn't load match history.");
      return;
    }
    if (this.state !== "menu" || this.homeView !== "history") return; // navigated away
    this.renderHistoryList(Array.isArray(matches) ? matches : []);
  }

Game.prototype.renderHistoryList = function (matches) {
    const wrap = document.getElementById("historyList");
    if (!wrap) return;
    wrap.innerHTML = "";
    if (!matches.length) {
      wrap.innerHTML = `<div class="room-empty">No matches recorded yet — play one!</div>`;
      return;
    }
    for (const m of matches) {
      const row = document.createElement("div");
      row.className = "room-row";
      row.innerHTML =
        `<div class="room-meta">` +
          `<span class="room-host">🏆 ${escapeHtml(m.champ || "—")}</span>` +
          `<span class="room-stats">${escapeHtml(modeLabel(m.mode))} · ${m.players} players · ${m.rounds} rounds · ${escapeHtml(fmtWhen(m.at))}</span>` +
        `</div>`;
      const btn = document.createElement("button");
      btn.className = "alt-btn room-join";
      btn.textContent = "VIEW";
      btn.onclick = () => { Sound.ui(); this.showMatchDetail(m.id); };
      row.appendChild(btn);
      wrap.appendChild(row);
    }
  }

Game.prototype.showMatchDetail = async function (id) {
    const list = document.getElementById("historyList");
    const detail = document.getElementById("historyDetail");
    if (!detail) return;
    this.showHistoryError("");
    let d;
    try {
      const res = await fetch(`/matches/${encodeURIComponent(id)}`, { cache: "no-store" });
      if (!res.ok) throw new Error("http " + res.status);
      d = await res.json();
    } catch (e) {
      this.showHistoryError("Couldn't load that match.");
      return;
    }
    if (list) list.classList.add("hidden");
    // The detail view has its own "← Matches" back button; hide the panel-level
    // "← Back" (both are corner-positioned .back-btn and would overlap).
    const panelBack = document.getElementById("historyBack");
    if (panelBack) panelBack.classList.add("hidden");
    const rows = (d.standings || []).map(p => ({
      name: p.bot ? `${p.name} 🤖` : p.name,
      wins: p.wins, dmg: p.dmg || 0, kills: p.kills || 0, you: false,
    }));
    detail.innerHTML =
      `<button class="back-btn" id="historyDetailBack" type="button">← Matches</button>` +
      `<div class="history-head">🏆 <b>${escapeHtml(d.champ || "—")}</b> · ${escapeHtml(modeLabel(d.mode))} · ${d.rounds} rounds · ${escapeHtml(fmtWhen(d.at))}</div>` +
      this.matchStatsHTML(rows, null) +
      `<div class="panel-feedback-links">` +
      `<button class="link-btn history-report-btn" type="button" id="historyReportBtn">Report feedback about this match ⚠️</button>` +
      `<a href="${DISCORD_INVITE_URL}" class="link-btn discord-link" target="_blank" rel="noopener noreferrer">Join our Discord</a>` +
      `</div>`;
    detail.classList.remove("hidden");
    const reportBtn = document.getElementById("historyReportBtn");
    if (reportBtn) {
      reportBtn.onclick = () => {
        Sound.ui();
        this.openReportCenter({ matchId: d.id, gameId: d.code || "", source: "history" });
      };
    }
    document.getElementById("historyDetailBack").onclick = () => {
      Sound.ui();
      this.historyBackToList();
    };
  }

Game.prototype.spellKeysReferenceHTML = function () {
    return SHOP_CATEGORY_ORDER.map(cat => {
      const spells = SPELLS_IN_CATEGORY(cat).map(id => {
        const s = SPELLS[id];
        return `<span class="sk-spell" style="--c:${s.color}" ${tipAttr("spell", id)}><span class="sk-ic">${spellIconInner(id)}</span>${escapeHtml(s.name)}</span>`;
      }).join("");
      return `<div class="sk-row"><span class="k">${escapeHtml(shopCategoryLabel(cat))}</span><div class="sk-list">${spells}</div></div>`;
    }).join("");
  }

Game.prototype.renderKeyReferences = function () {
    const html = this.spellKeysReferenceHTML();
    const sk = document.getElementById("lobbySpellList");
    if (sk) sk.innerHTML = html;
  }

Game.prototype.renderKeybinds = function () {
    for (const id of ["keybindList", "mmKeybindList"]) {
      const wrap = document.getElementById(id);
      if (wrap) this.renderKeybindsInto(wrap);
    }
  }

Game.prototype.renderKeybindsInto = function (wrap) {
    if (!wrap) return;
    wrap.innerHTML = "";
    const groups = [
      { title: "Action Bar 1", slots: SLOT_ORDER.filter(s => "1234".includes(s)) },
      { title: "Action Bar 2", slots: SLOT_ORDER.filter(s => "QWER".includes(s)) },
      { title: "Space Bar", slots: SLOT_ORDER.filter(s => s === "Space") },
    ];
    groups.forEach(group => {
      if (!group.slots.length) return;
      const heading = document.createElement("div");
      heading.className = "kb-group-title";
      heading.textContent = group.title;
      wrap.appendChild(heading);
      group.slots.forEach(slot => {
        const row = document.createElement("div");
        row.className = "kb-row";
        row.innerHTML = `<div class="kb-spells"></div>`;
        const btn = document.createElement("button");
        btn.className = "kb-key";
        btn.type = "button";
        btn.textContent = keyLabelForSlot(slot);
        btn.onclick = () => this.startRebind(slot, btn);
        row.appendChild(btn);
        wrap.appendChild(row);
      });
    });
  }

Game.prototype.startRebind = function (slot, btn) {
    this._teardownRebind();   // restore any other in-progress button first
    btn.classList.add("listening");
    btn.textContent = "Press a key…";
    const onKey = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.key === "Escape") { this._teardownRebind(); return; }
      const label = eventKeyLabel(e);
      if (!label || RESERVED_KEYS.has(label)) { btn.textContent = "Reserved — try another"; return; }
      const prev = KEYBINDS[slot];
      const conflict = SLOT_ORDER.find(s => s !== slot && (KEYBINDS[s] || s) === label);
      if (conflict) KEYBINDS[conflict] = prev;
      KEYBINDS[slot] = label;
      saveKeybinds();
      rebuildKeyToSlot();
      this._teardownRebind();
      this.renderKeybinds();
      this.renderKeyReferences();
      Sound.ui();
    };
    this._rebind = { slot, btn, onKey };
    window.addEventListener("keydown", onKey, true);
  }

Game.prototype._teardownRebind = function () {
    if (!this._rebind) return;
    window.removeEventListener("keydown", this._rebind.onKey, true);
    const { btn, slot } = this._rebind;
    if (btn && btn.isConnected) { btn.classList.remove("listening"); btn.textContent = keyLabelForSlot(slot); }
    this._rebind = null;
  }

Game.prototype.cancelRebind = function () { this._teardownRebind(); }

Game.prototype.resetKeybinds = function () {
    SLOT_ORDER.forEach(s => { KEYBINDS[s] = DEFAULT_BINDS[s] || s; });
    saveKeybinds();
    rebuildKeyToSlot();
    this.renderKeybinds();
    this.renderKeyReferences();
    Sound.ui();
  }

Game.prototype.banner = function (text, ms, top = false) {
    this.bannerText = text;
    const el = document.getElementById("banner");
    if (!el) return;
    el.textContent = text;
    // During round-over the scoreboard is centered, so pin the result banner to
    // the top to avoid overlapping it; countdown banners stay centered.
    el.classList.toggle("top", !!top);
    el.classList.remove("hidden");
    if (this._bannerTO) clearTimeout(this._bannerTO);
    if (ms) this._bannerTO = setTimeout(() => el.classList.add("hidden"), ms);
  }

Game.prototype.updateCamera = function (dt) {
    let tx = this.ax, ty = this.ay;
    if (this.inSpectateView()) {
      const w = this.spectateTarget();
      if (w) { tx = w.x; ty = w.y; }
    } else {
      const h = this.human();
      if (h) { tx = h.x; ty = h.y; }
    }
    // keep the camera within the arena so you never stare into empty void
    const dcx = tx - this.ax, dcy = ty - this.ay, dc = len(dcx, dcy);
    const limit = this.maxRadius * 0.92;
    if (dc > limit) { tx = this.ax + dcx / dc * limit; ty = this.ay + dcy / dc * limit; }
    const k = 1 - Math.exp(-CFG.camLerp * dt);
    this.camX += (tx - this.camX) * k;
    this.camY += (ty - this.camY) * k;
  }

Game.prototype.matchStatsHTML = function (rows, breakdown) {
    rows = [...rows].sort((a, b) => (b.wins - a.wins) || (b.dmg - a.dmg));
    const teamTable = rows.some(r => /^Team \d+/.test(r.name));
    const nameCol = teamTable ? "Team" : "Warlock";
    let html = `<table class="mo-stats"><tr><th>${nameCol}</th><th>Rounds won</th><th>Dmg</th><th>Kills</th></tr>`;
    for (const r of rows) {
      const nameCell = playerNameHTML(r.name, "", 0, r.admin) + (r.leaver ? " (leaver)" : "");
      html += `<tr class="${r.you ? "you" : ""}"><td>${nameCell}</td><td>${r.wins}</td><td>${Math.round(r.dmg)}</td><td>${r.kills}</td></tr>`;
    }
    html += `</table>`;
    if (breakdown) {
      const items = Object.entries(breakdown).filter(([, v]) => v > 0).sort((a, b) => b[1] - a[1]);
      if (items.length) {
        html += `<div class="mo-break"><b>Your damage by spell</b><br>` +
          items.map(([id, v]) => `${spellLabelHTML(id)}: ${Math.round(v)}`).join("  ·  ") +
          `</div>`;
      }
    }
    return html;
  }
